module.exports = __webpack_public_path__ + "img/sd.2d8d67cf.jpg";